import React from "react";

export default function Contact() {
  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        padding: "3rem",
        fontFamily: "Arial, sans-serif",
        color: "#1E2A38",
        textAlign: "center",
        minHeight: "100vh",
      }}
    >
      <h1 style={{ color: "#4A7C59", fontSize: "2.5rem", marginBottom: "2rem" }}>
        Contact
      </h1>

      <p style={{ fontSize: "1.2rem", margin: "1rem 0" }}>
        Email:{" "}
        <a href="mailto:benjamin.hoch@me.com" style={{ color: "#4A7C59", textDecoration: "none" }}>
          benjamin.hoch@me.com
        </a>
      </p>

      <p style={{ fontSize: "1.2rem", margin: "1rem 0" }}>
        Mobile:{" "}
        <a href="tel:+61432731555" style={{ color: "#4A7C59", textDecoration: "none" }}>
          +61 432 731 555
        </a>
      </p>

      <p style={{ fontSize: "1.2rem", margin: "1rem 0" }}>
        <a
          href="https://www.facebook.com/profile.php?id=61575952394340"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#4A7C59", textDecoration: "none" }}
        >
          Facebook
        </a>
      </p>

      <p style={{ fontSize: "1.2rem", margin: "1rem 0" }}>
        <a
          href="https://www.instagram.com/benjaminjhoch?igsh=bXF5anVzMHpwbzZp&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#4A7C59", textDecoration: "none" }}
        >
          Instagram
        </a>
      </p>

      <p style={{ fontSize: "1.2rem", margin: "1rem 0" }}>
        Book a Chat:{" "}
        <a
          href="https://benjaminhoch.youcanbook.me/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#FFFFFF",
            backgroundColor: "#4A7C59",
            padding: "0.5rem 1rem",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "bold",
            display: "inline-block",
          }}
        >
          BOOK HERE
        </a>
      </p>
    </div>
  );
}
